<template>
  <v-container fluid>
    <v-card flat outlined class="pa-sm-4 wraperx" v-if="loading">
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </v-card>
    <v-card flat outlined class="pa-sm-4 wraperx" v-else>
      <v-card-title class="primary--text">
        Vehicle Running Logs
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          @click="newItem()"
          v-if="
            $_checkPermission(
              this.auth.permissions,
              'Manage Vehicle Running Logs',
              'Create'
            )
          "
        >
          <v-icon left> mdi-plus </v-icon> New Log
        </v-btn>
      </v-card-title>
      <v-card-title
        class="justify-center justify-sm-start"
        v-if="
          $_checkPermission(
            this.auth.permissions,
            'Manage Vehicle Running Logs',
            'Read All'
          ) ||
          $_checkPermission(
            this.auth.permissions,
            'Manage Vehicle Running Logs',
            'Read Sub'
          )
        "
      >
        <v-card outlined>
          <v-tabs
            v-model="tab"
            @change="changeView"
            background-color="transparent"
          >
            <v-tooltip bottom max-width="200">
              <template v-slot:activator="{ on, attrs }">
                <v-tab
                  style="
                    overflow-x: hidden !important;
                    word-break: keep-all;
                    text-overflow: ellipsis !important;
                    max-width: calc(50vw - 50px);
                    min-width: 0 !important;
                  "
                  v-bind="attrs"
                  v-on="on"
                  :tab-value="1"
                  >My</v-tab
                >
              </template>
              <span>View your running logs</span>
            </v-tooltip>
            <v-divider
              vertical
              v-if="
                $_checkPermission(
                  this.auth.permissions,
                  'Manage Vehicle Running Logs',
                  'Read Sub'
                )
              "
            ></v-divider>
            <v-tooltip
              bottom
              max-width="200"
              v-if="
                $_checkPermission(
                  this.auth.permissions,
                  'Manage Vehicle Running Logs',
                  'Read Sub'
                )
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tab
                  style="
                    overflow-x: hidden !important;
                    word-break: keep-all;
                    text-overflow: ellipsis !important;
                    max-width: calc(50vw - 50px);
                    min-width: 0 !important;
                  "
                  v-bind="attrs"
                  v-on="on"
                  :tab-value="3"
                  >Sub</v-tab
                >
              </template>
              <span>View running logs of your subordinates</span>
            </v-tooltip>

            <v-divider
              vertical
              v-if="
                $_checkPermission(
                  this.auth.permissions,
                  'Manage Vehicle Running Logs',
                  'Read All'
                )
              "
            ></v-divider>
            <v-tooltip
              bottom
              max-width="200"
              v-if="
                $_checkPermission(
                  this.auth.permissions,
                  'Manage Vehicle Running Logs',
                  'Read All'
                )
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tab
                  style="
                    overflow-x: hidden !important;
                    word-break: keep-all;
                    text-overflow: ellipsis !important;
                    max-width: calc(50vw - 50px);
                    min-width: 0 !important;
                  "
                  v-bind="attrs"
                  v-on="on"
                  :tab-value="2"
                  >All</v-tab
                >
              </template>
              <span>View all running logs</span>
            </v-tooltip>
          </v-tabs>
        </v-card>
      </v-card-title>
      <v-card-title class="primary--text">
        <v-text-field
          filled
          dense
          outlined
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @change="modifyQuery('search', search)"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        mobile-breakpoint="0"
        :headers="headers"
        :items="items"
        :search="search"
      >
        <template v-slot:item.review_status="{ item }">
          <v-chip
            small
            dark
            :color="
              item.review_status == 'APPROVED'
                ? 'green'
                : item.review_status == 'REJECTED'
                ? 'error'
                : 'amber darken-2'
            "
            >{{
              item.review_status == "APPROVED"
                ? "Approved"
                : item.review_status == "REJECTED"
                ? "Rejected"
                : "Pending"
            }}</v-chip
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.edit_status == 'DISABLED'"
            depressed
            small
            color="primary"
            class="mx-0 px-0 mt-1"
            dark
            @click="viewItem(item)"
          >
            more
          </v-btn>
          <v-badge
            bordered
            :color="
              item.edit_status == 'REQUEST_WAITING'
                ? 'orange'
                : item.edit_status == 'REQUEST_REJECTED'
                ? 'error'
                : 'green'
            "
            dot
            overlap
            v-else
          >
            <v-btn
              depressed
              small
              color="primary"
              class="mx-0 px-0 mt-1"
              dark
              @click="viewItem(item)"
            >
              more
            </v-btn>
          </v-badge>
        </template>
        <template v-slot:item.description="{ item }">
          <v-sheet class="text-truncate" max-width="200" color="transparent">
            {{ item.description }}
          </v-sheet>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-sheet
          class="d-flex align-center text-caption px-2"
          color="transparent"
        >
          <v-badge dot color="orange" class="me-3"></v-badge> Edit Access
          Requested
        </v-sheet>
        <v-sheet
          class="d-flex align-center text-caption px-2"
          color="transparent"
        >
          <v-badge dot color="red" class="me-3"></v-badge> Edit Access Rejected
        </v-sheet>
        <v-sheet
          class="d-flex align-center text-caption px-2"
          color="transparent"
        >
          <v-badge dot color="green" class="me-3"></v-badge> Edit Access Granted
        </v-sheet>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
    
    
    <script>
import { mapState } from "vuex";
import { fetchAndStoreMyVehicleRunning } from "@/services/myDataService";
import { syncOfflineVehicleRunningChanges } from "@/services/vehicleRunningService";
export default {
  components: {
    //
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  watch: {
    //
  },
  data: () => ({
    newQuery: {},
    tab: 1,
    loading: false,
    search: "",
    headers: [
      {
        text: "Log Id",
        value: "id",
      },
      {
        text: "Date",
        value: "date",
      },
      { text: "Vehicle", value: "vehicles.vehicle_no" },
      { text: "Project", value: "projects.code" },
      { text: "Meter Box", value: "meter_box_id", sortable: false },
      { text: "Dispatch (km)", value: "dispatch_km", sortable: false },
      { text: "Return (km)", value: "return_km", sortable: false },
      { text: "Total (km)", value: "total_km" },
      { text: "Status", value: "review_status", sortable: false },
      { text: "Action", value: "actions", sortable: false },
    ],
    items: [],
  }),
  async created() {
    this.loading = true;
    await syncOfflineVehicleRunningChanges();
    this.items = await fetchAndStoreMyVehicleRunning();
    const query = this.$route.query;
    this.search = query.search || this.search;
    this.loading = false;
  },
  mounted() {
    //
  },
  methods: {
    viewItem(item) {
      if (JSON.stringify(this.newQuery) != JSON.stringify(this.$route.query)) {
        this.$router.replace({ path: this.$route.path, query: this.newQuery });
      }

      this.$router.push({
        name: "PageViewVehicleRunning",
        params: { uuid: item.uuid },
        query: { bc: item.id, mylog: "true" },
      });
    },
    newItem() {
      this.$router.push({ name: "PageNewVehicleRunning" });
    },
    changeView() {
      if (this.tab == 2) {
        this.$router.push({
          name: "PageAllVehicleRunningList",
        });
      }
      if (this.tab == 3) {
        this.$router.push({
          name: "PageSubVehicleRunningList",
        });
      }
    },
    modifyQuery(queryKey, value) {
      // Create the new query object with updated value
      this.newQuery = { ...this.$route.query, [queryKey]: value || undefined };

      // Check if the query parameters have changed
      // const isSameQuery =
      //   JSON.stringify(newQuery) === JSON.stringify(this.$route.query);

      // If the query has not changed, do nothing
      // if (isSameQuery) {
      //   return;
      // }

      // Otherwise, update the query with replace (avoiding page reload)
      // this.$router.replace({ path: this.$route.path, query: newQuery });
    },
  },
};
</script>